import React, { Component } from 'react';
import axios from 'axios';
import { adpatGamesToUsersTimeZone } from '../utils/api-adpters';
import AllMatchesPage from './all-matches-page';
import { adaptAllMatchesFromWebsocket } from "../utils/websocket-adapters";
import { getTodayStringUtc, getDateText, getDateString } from '../utils/date-utils';
import Dropdown from './dropdown';

class MainWeb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      showMenu: false,
      isLoading: true,
      selectedDay: getTodayStringUtc(),
    };

    this._isMounted = false;
    this.getAcademiaCompetitionsList();
    this.handleChangeDay = this.handleChangeDay.bind(this);
    this.dropdownDaysArray = this.getSevenDays();

    this.updateDataFromLivescores = this.updateDataFromLivescores.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateDataFromLivescores(games) {
    const newStateData = adaptAllMatchesFromWebsocket(this.state.data, games);
    if (this._isMounted) {
      this.setState({
        data: newStateData,
      })
    }
  }

  getSevenDays() {
    const today = new Date();
    const todayLess1 = new Date(new Date().setDate(new Date().getDate() - 1));
    const todayLess2 = new Date(new Date().setDate(new Date().getDate() - 2));
    const todayLess3 = new Date(new Date().setDate(new Date().getDate() - 3));
    const todayPlus1 = new Date(new Date().setDate(new Date().getDate() + 1));
    const todayPlus2 = new Date(new Date().setDate(new Date().getDate() + 2));
    const todayPlus3 = new Date(new Date().setDate(new Date().getDate() + 3));

    const todayKey = getDateString(today);
    const todayLess1Key = getDateString(todayLess1);
    const todayLess2Key = getDateString(todayLess2);
    const todayLess3Key = getDateString(todayLess3);
    const todayPlus1Key = getDateString(todayPlus1);
    const todayPlus2Key = getDateString(todayPlus2);
    const todayPlus3Key = getDateString(todayPlus3);

    const todayValue = getDateText(todayKey);
    const todayValueLess1 = getDateText(todayLess1Key);
    const todayValueLess2 = getDateText(todayLess2Key);
    const todayValueLess3 = getDateText(todayLess3Key);
    const todayValuePlus1 = getDateText(todayPlus1Key);
    const todayValuePlus2 = getDateText(todayPlus2Key);
    const todayValuePlus3 = getDateText(todayPlus3Key);

    const sevenDaysArray = [
      [todayLess3Key, todayValueLess3],
      [todayLess2Key, todayValueLess2],
      [todayLess1Key, todayValueLess1],
      [todayKey, 'Hoje', todayValue],
      [todayPlus1Key, todayValuePlus1],
      [todayPlus2Key, todayValuePlus2],
      [todayPlus3Key, todayValuePlus3],
    ];
    return sevenDaysArray;
  }

  getInstanceAcademia = () =>
    axios.create({
      baseURL: 'https://www.academiadasapostas.com',
    });

  getAcademiaCompetitionsList() {
    const request = this.getInstanceAcademia()({
      method: 'get',
      url: '/api/?mode=web&jsonrpc={"jsonrpc":"2.0","method":"get_all_matches","params":{"total_days": 3},"id":1}',
    });
    return request
      .then(response => {
        let gamesByDay = adpatGamesToUsersTimeZone(response.data.result)
        this.setState({
          ...this.state,
          data: gamesByDay,
          isLoading: false,
        })
      });
  }

  /**
   * 
   * @param {*} newDay format aaaa-mm-dd
   */
  handleChangeDay(newDay) {
    this.setState({
      selectedDay: newDay,
    })
  }

  printOrderCompetition() {
    const competitionOrder = this.state.data[this.state.selectedDay].sort((a, b) => {
      if (this.state.asc) {
        if (a.area_id < b.area_id) {
          return -1;
        }
        else {
          return 1;
        }
      } else {
        if (a.area_id > b.area_id) {
          return -1;
        }
        else {
          return 1;
        }
      }
    });
    this.setState({
      [this.state.data]: competitionOrder,
      asc: !this.state.asc,
    })
  }

  printOrderClock() {
    const clockOrder = this.state.data[this.state.selectedDay].sort((a, b) => {
      if (this.state.asc) {
        if (a.time_utc < b.time_utc) {
          return -1;
        }
        else {
          return 1;
        }
      } else {
        if (a.time_utc > b.time_utc) {
          return -1;
        }
        else {
          return 1;
        }
      }
    });
    this.setState({
      [this.state.data]: clockOrder,
      asc: !this.state.asc,
    })
  }

  printOrderHome() {
    const homeOrder = this.state.data[this.state.selectedDay].sort((a, b) => {
      if (this.state.asc) {
        if (a.team_A_name < b.team_A_name) {
          return -1;
        }
        else {
          return 1;
        }
      } else {
        if (a.team_A_name > b.team_A_name) {
          return -1;
        }
        else {
          return 1;
        }
      }
    });
    this.setState({
      [this.state.data]: homeOrder,
      asc: !this.state.asc,
    })
  }

  printOrderAway() {
    const homeOrder = this.state.data[this.state.selectedDay].sort((a, b) => {
      if (this.state.asc) {
        if (a.team_B_name < b.team_B_name) {
          return -1;
        }
        else {
          return 1;
        }
      } else {
        if (a.team_B_name > b.team_B_name) {
          return -1;
        }
        else {
          return 1;
        }
      }
    });
    this.setState({
      [this.state.data]: homeOrder,
      asc: !this.state.asc,
    })
  }


  renderGames() {
    if (!this.state.data.hasOwnProperty(this.state.selectedDay) || this.state.isLoading) {
      return (
        <tr>
          <td colSpan="9">
            <div className="is-loading">
              <div className="loader"></div>
            </div>
          </td>
        </tr>
      )
    } else {
      return (
        <AllMatchesPage
          matches={this.state.data[this.state.selectedDay]}
          handleLivescores={this.updateDataFromLivescores}
        />
      )
    }
  }

  render() {
    return (
      <div>
        <Dropdown
          handleChange={this.handleChangeDay}
          selectedKey={this.state.selectedDay}
          values={this.dropdownDaysArray}
        />
        <table className="table" border="0" cellSpacing="0" cellPadding="0">
          <thead className="table-header">
            <tr>
              <th className="iconflag" onClick={() => this.printOrderCompetition()}><img src="/img/flag.png" alt="comp-flag" /></th>
              <th className="award"></th>
              <th className="clockorder" onClick={() => this.printOrderClock()}><img border="0" src="/img/watch.png" alt="watch" /></th>
              <th className="homeorder" onClick={() => this.printOrderHome()}><span>Casa</span></th>
              <th></th>
              <th className="awayorder" onClick={() => this.printOrderAway()}><span>Fora</span>
              </th>
              <th className="stats-mobile"></th>
              <th className="streaming"><img border="0" src="/img/Tv.png" alt="tv" /></th>
              <th className="liveText-mobile"></th>
            </tr>
          </thead>
          <tbody className="table-body hover-tr">
            {this.renderGames()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default MainWeb;
